<template>
  <div>
    <transition name="fade" mode>
      <!-- added regions -->
      <div v-if="!norwaySelected">
        <transition-group name="fade2">
          <div class="card" v-for="(county, index) in addedCounties" :key="'c'+county.countyId">
            <div class="card-body card-body-added" @click="editRegions(county.countyId)">
              <div class="card-links">
                <a href="#" @click.prevent>
                  <small>Endre</small>
                </a>
                <a href="#" @click.prevent.stop="deleteRegion(county.countyId)">
                  <small>Fjern</small>
                </a>
              </div>

              <h6>Område {{index + 1}}</h6>
              {{county.countyName}} {{numberOfMunicipalities(county.countyId)}}
            </div>
          </div>
        </transition-group>
      </div>
    </transition>

    <transition name="fade" mode>
      <!-- Norway is selected -->
      <div v-if="norwaySelected">
        <div class="card">
          <div class="card-body card-body-added" @click="editRegions(0)">
            <div class="card-links">
              <a href="#" @click.prevent.stop="deleteRegion(0)">
                <small>Endre</small>
              </a>
              <br />
            </div>

            <h6>Område 1</h6>Hele Norge
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade" mode>
      <!-- Add more card -->
      <div
        class="card"
        v-if="(showAddRegion || addedMunicipalities < 1) && norwaySelected == false"
      >
        <div class="card-body card-body-added">
          <div class="card-links">
            <a
              href="#"
              @click.stop
              @click="deleteRegion(-1)"
              v-if="selectedCounty && selectedCounty.countyId >= 0"
            >
              <small>Fjern</small>
            </a>
          </div>

          <h6>Legg til område</h6>
          <select class="region-select" v-model="selectedCounty" @change="countyChanged">
            <option
              class="one-bold"
              v-for="county in counties"
              :key="county.countyId"
              :value="county"
            >{{ county.countyName }}</option>
          </select>
          <div v-if="selectedCounty.countyId > 0">
            <fieldset
              class="boxes"
              v-if="!(visibleMunicipalities.length === 1 && visibleMunicipalities[0].councilName != visibleMunicipalities[0].countyName)"
            >
              <input
                type="checkbox"
                v-model="allMunicipalitiesSelected"
                id="allMunicipalitiesSelect"
                @change="allMunicipalitiesChanged"
              />
              <label for="allMunicipalitiesSelect" class="input-label">
                <span v-if="selectedCounty.municipalityCount > 1">Alle kommuner i</span>
                {{selectedCounty.countyName}}
              </label>
            </fieldset>

            <fieldset class="boxes">
              <ul
                v-if="visibleMunicipalities.length > 1 || (visibleMunicipalities.length === 1 && visibleMunicipalities[0].councilName != visibleMunicipalities[0].countyName)"
              >
                <li v-for="muni in visibleMunicipalities" :key="muni.councilId">
                  <label class="input-label" :for="muni.councilName">
                    <input
                      type="checkbox"
                      :id="muni.councilName"
                      :value="muni"
                      v-model="selectedMunicipalities"
                      @change="selectedMunicipalitiesChanged"
                    />
                    {{muni.councilName}}
                  </label>
                </li>
              </ul>
            </fieldset>
          </div>
        </div>
      </div>
    </transition>
    <!-- add more -->
    <transition name="fade" mode>
      <div
        v-if="showAddAnotherRegion() && !(
        ((showAddRegion || addedMunicipalities < 1) && norwaySelected == false) && !(selectedCounty && selectedCounty.countyId >= 0)
        )"
      >
        <button type="button" @click="addMoreRegions" class="btn btn-nve btn-add-more">
          <span class="add-more-plus">+</span>
          <span>Legg til enda et varslingsområde</span>
        </button>
      </div>
    </transition>
  </div>
</template>

<script>
import TypeService from '../store/TypeService.js';

export default {
  name: "CountySelector",
  props: {
    existingSubscription: {},
    subscriptionType: {},
    regions: []
  },
  data() {
    return {
      TypeService: TypeService,
      selectedCounty: {
        countyId: -1,
        countyName: "Velg fylke",
        municipalityCount: 0
      },
      selectedMunicipalities: [],
      addedMunicipalities: [],
      allMunicipalitiesSelected: false,
      norwaySelected: false,
      showAddRegion: true
    };
  },
  computed: {
    counties() {
      let counties = [
        { countyId: -1, countyName: "Velg fylke", municipalityCount: 0 }
      ];
      counties.push({
        countyId: 0,
        countyName: "Hele Norge",
        municipalityCount: 0
      });
      counties = counties.concat(this.$store.getters.counties);

      if (this.addedCounties.length > 0) {
        // Romove already added counties
        for (let i = 0; i < this.addedCounties.length; i += 1) {
          const county = this.addedCounties[i];
          for (let j = 0; i < counties.length; j += 1) {
            if (county === counties[j]) {
              counties.splice(j, 1);
              break;
            }
          }
        }
      }

      if (
        this.subscriptionType.hazardTypeId === TypeService.Flood ||
        this.subscriptionType.hazardTypeId === TypeService.Landslide
      ) {
        // dont show Svalbard for flood and landslide
        for (let i = 0; i < counties.length; i += 1) {
          const county = counties[i];
          if (county.countyId === 21) {
            counties.splice(i, 1);
            break;
          }
        }
      }

      return counties;
    },
    addedCounties() {
      const addedCounties = [];
      const counties = this.$store.getters.counties;

      for (let i = 0; i < this.addedMunicipalities.length; i += 1) {
        const countyNumber = this.addedMunicipalities[i].countyId;

        for (let j = 0; j < counties.length; j += 1) {
          const county = counties[j];
          let exists = false;
          for (let k = 0; k < addedCounties.length; k += 1) {
            const addedCounty = addedCounties[k];
            if (addedCounty.countyId === countyNumber) {
              exists = true;
            }
          }
          if (!exists && county.countyId === countyNumber) {
            addedCounties.push(county);
          }
        }
      }
      return addedCounties;
    },
    visibleMunicipalities() {
      if (!this.selectedCounty) {
        return [];
      }
      if (this.selectedCounty < 1) {
        return [];
      }
      return this.$store.getters.municipalities.filter(
        muni => muni.countyId === this.selectedCounty.countyId
      );
    }
  },
  created() {
    this.reset();
  },
  methods: {
    reset() {
      if (this.existingSubscription) {
        if (this.existingSubscription.isRegionNorway) {
          this.selectedCounty = {
            countyId: 0,
            countyName: "Hele Norge",
            municipalityCount: 0
          };
          this.norwaySelected = true;
        }
        if (
          this.existingSubscription.municipalities &&
          this.existingSubscription.municipalities.length > 0
        ) {
          const municipalities = this.$store.getters.municipalities;
          for (let i = 0; i < municipalities.length; i += 1) {
            const muni = municipalities[i];
            if (this.existingSubscription.municipalities.indexOf(muni.councilId) > -1) {
              this.addedMunicipalities.push(muni);
            }
          }
        }
        this.showAddRegion =
          !this.existingSubscription ||
          (this.existingSubscription.municipalities &&
            this.existingSubscription.municipalities.length === 0);
      }
    },
    showAddAnotherRegion() {
      return (
        (this.selectedMunicipalities &&
          this.selectedMunicipalities.length > 0) ||
        (this.addedMunicipalities && this.addedMunicipalities.length > 0) ||
        (this.existingSubscription &&
          this.existingSubscription.municipalities &&
          this.existingSubscription.municipalities.length > 0)
      );
    },
    editRegions(countyId) {
      if (this.selectedCounty && this.selectedCounty.countyId > 0) {
        // we are editing something at the moment, so we should store before switching
        this.addMoreRegions();
      }

      if (countyId === 0) {
        this.deleteRegion(0);
        return;
      }

      // load data from added-subscription
      this.prepareToEditCounty(countyId);
      // show add region element
      this.showAddRegion = true;
      // triger UI updates
      this.selectedMunicipalitiesChanged();
    },
    prepareToEditCounty(countyId) {
      // get from added county
      const addedCounty = this.addedCounties.filter(
        county => county.countyId === countyId
      )[0];
      // remove from currently added
      this.addedCounties.splice(this.addedCounties.indexOf(addedCounty));

      // get municipalities from county
      const selected = this.addedMunicipalities.filter(
        mun => mun.countyId === countyId
      );
      // remove from added
      this.addedMunicipalities = this.addedMunicipalities.filter(
        mun => mun.countyId != countyId
      );

      // flag as selected
      this.selectedMunicipalities = selected;
      this.selectedCounty = addedCounty;
    },
    addMoreRegions() {
      this.addedMunicipalities = this.addedMunicipalities.concat(
        this.selectedMunicipalities
      );
      this.showAddRegion = true;
      this.selectedMunicipalities = [];
      this.selectedCounty = {
        countyId: -1,
        countyName: "Velg fylke",
        municipalityCount: 0
      };

      this.emitSelectedAndAddedMunicipalities();
    },
    deleteRegion(countyId) {
      if (countyId === -1) {
        // delete current selection
        if (this.selectedCounty && this.selectedCounty.countyId >= 0) {
          this.deleteRegion(this.selectedCounty.countyId);
        }
        this.selectedMunicipalities = [];
        this.selectedCounty = {
          countyId: -1,
          countyName: "Velg fylke",
          municipalityCount: 0
        };
        this.showAddRegion = false;
        this.emitSelectedAndAddedMunicipalities();
        return;
      }

      if (countyId === 0) {
        // hele norge
        this.norwaySelected = false;
        this.selectedMunicipalities = [];
        this.selectedCounty = {
          countyId: -1,
          countyName: "Velg fylke",
          municipalityCount: 0
        };
      } else {
        for (let i = this.addedMunicipalities.length - 1; i >= 0; i -= 1) {
          if (this.addedMunicipalities[i].countyId === countyId) {
            this.addedMunicipalities.splice(i, 1);
          }
        }
      }
      this.emitSelectedAndAddedMunicipalities();
    },
    countyChanged() {
      if (this.selectedCounty.countyId === 0) {
        // Hele norge
        this.norwaySelected = this.selectedCounty.countyId === 0; // hele norge
        this.addedMunicipalities = [];
      }

      this.selectedMunicipalities = [];
      if (this.selectedCounty.countyId === 21) {
        this.selectedMunicipalities.push(this.visibleMunicipalities[0]);
        this.allMunicipalitiesSelected = false;
      }
      this.allMunicipalitiesSelected = this.selectedCounty.countyId > 0;
      this.allMunicipalitiesChanged();

      this.emitSelectedAndAddedMunicipalities();
    },
    allMunicipalitiesChanged() {
      if (this.allMunicipalitiesSelected) {
        this.selectedMunicipalities = this.visibleMunicipalities;
      } else {
        this.selectedMunicipalities = [];
      }
      this.emitSelectedAndAddedMunicipalities();
    },
    selectedMunicipalitiesChanged() {
      this.allMunicipalitiesSelected =
        this.visibleMunicipalities.length ===
        this.selectedMunicipalities.length;
      this.emitSelectedAndAddedMunicipalities();
    },
    emitSelectedAndAddedMunicipalities() {
      this.$emit(
        "regionAdded",
        this.addedMunicipalities.concat(this.selectedMunicipalities)
      );
      this.$emit("norwaySelected", this.norwaySelected);
    },
    numberOfMunicipalities(countyid) {
      let count = 0;
      for (let i = 0; i < this.addedMunicipalities.length; i += 1) {
        const muni = this.addedMunicipalities[i];
        if (muni.countyId === countyid) {
          count += 1;
        }
      }
      if (count < 1) {
        return "";
      } else if (count === 1) {
        return `(${this.addedMunicipalities.filter(m=>m.countyId === countyid)[0].councilName} kommune)`;
      }

      return `(${count} kommuner)`;
    },
    clearAddedMunicipalities() {
      this.norwaySelected = false;
      this.addedMunicipalities = [];
      this.selectedCounty = {
        countyId: -1,
        countyName: "Velg fylke",
        municipalityCount: 0
      };
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.card-body {
  background-color: rgba(4, 73, 98, 0.035);
}

.region-select {
  height: 36px;
  border: 1px solid #979797;
  border-radius: 2px;
  font-size: 16px;
  line-height: 140%;
  color: #444444;
  width: 80%;
  margin-bottom: 16px;

  padding-left: 8px;
  cursor: pointer;
}

option.one-bold:nth-child(2) {
  font-weight: bold;
}
option.two-bold:nth-child(2) {
  font-weight: bold;
}
option.two-bold:nth-child(3) {
  font-weight: bold;
}

.wrapper {
  margin: 0;
  padding: 0;
}
</style>
